export enum EUserRole {
  Admin = 'Admin',
  Employee = 'Employee',
  Manager = 'Manager',
  Warehouse = 'Warehouse',
  SuperAdmin = 'SuperAdmin',
  Collector = 'Collector',
  Observe = 'Observe',
  Driver = 'Driver',
}
